export var version = '3.7.10';
//# sourceMappingURL=version.js.map